import React from 'react';
import { StandardPdfTemplate } from '../../templates/StandardPdfTemplate';
import { ProjectData, ProjectInfoData } from '../../shared/types/PdfCommonTypes';
import { TFunction } from 'i18next';
import { ContainerYardResultsCore } from './sections/ContainerYardResultsCore';

interface ContainerYardResultsPdfDocumentProps {
    output: any;
    projectInfo: any;
    dynamicProject: any;
    tireImageUnreinforced: string;
    tireImageReinforced: string;
    chartImage: string;
    t: TFunction;
}

const ContainerYardResultsPdfDocumentV2: React.FC<ContainerYardResultsPdfDocumentProps> = ({ output, projectInfo, dynamicProject, tireImageUnreinforced, tireImageReinforced, chartImage, t }) => {
    // Extract project information
    const projectData = dynamicProject?.data;
    const projectInfoData = projectData?.projectInfo;
    const projectMapImage = projectData?.mapImage;
    const unitSystem = dynamicProject?.data?.unit || 'Metric';
    const projectType = dynamicProject?.data?.type || 'container_yard';
    const isParkingDeck = projectType === 'parking_deck' || projectType === 'parkingdeck';
    const calculationMethodKey = projectData?.method || projectInfo?.method || projectInfoData?.data?.method;
    const subtitleKey = calculationMethodKey === 'static' ? 'subtitle_container_yard_static' : 'subtitle_container_yard_bcr';
    const subtitleFallback = calculationMethodKey === 'static' ? 'STATIC METHOD' : 'BCR METHOD';
    const subtitleText = t(subtitleKey) || `Designing ${subtitleFallback}`;

    // Prepare data for StandardPdfTemplate
    const projectDataForTemplate: ProjectData = {
        projectName: projectData?.projectName || 'N/A',
        projectType: projectType,
        unit: unitSystem,
        mapImage: projectMapImage,
    };

    const projectInfoDataForTemplate: ProjectInfoData = {
        data: {
            nrProject: projectInfo?.nrProject || projectInfoData?.data?.nrProject || 'N/A',
        },
        projectOwner: projectInfo?.projectOwner || projectInfoData?.projectOwner || 'N/A',
        designerFirmName: projectInfo?.designerFirmName || projectInfoData?.designerFirmName || 'N/A',
        designerFirmCountry: projectInfo?.designerFirmCountry || projectInfoData?.designerFirmCountry || 'N/A',
        designerFirmCity: projectInfo?.designerFirmCity || projectInfoData?.data?.designerFirmCity || 'N/A',
        coordinates: projectInfo?.coordinates || projectInfoData?.coordinates || [null, null],
    };

    return (
        <StandardPdfTemplate
            projectType={projectType}
            projectData={projectDataForTemplate}
            projectInfoData={projectInfoDataForTemplate}
            t={t}
            headerConfig={{
                customTitle: t('pdf_header_technical_report_groundmac') || 'GROUNDMAC - Design Technical Report',
                customProjectType: isParkingDeck ? t('project_type_parking_deck') || 'Parking Deck' : t('project_type_container_yard') || 'Container Yard',
                customSubtitle: subtitleText,
                showGeogridSubtitle: false,
            }}
            footerConfig={{
                customText: t('pdf_footer') || 'MACread eDesign',
                customNotice: t('pdf_footer_notice') || 'Footer notice',
            }}
            showProjectInfo={true}>
            {/* Use the shared core component */}
            <ContainerYardResultsCore
                output={output}
                projectData={projectData}
                tireImageUnreinforced={tireImageUnreinforced}
                tireImageReinforced={tireImageReinforced}
                chartImage={chartImage}
                t={t}
                showInputData={true}
                showChart={true}
                showResults={true}
            />
        </StandardPdfTemplate>
    );
};

export default ContainerYardResultsPdfDocumentV2;
